module.exports = __webpack_public_path__ + "img/selected2-min.e3c2d06d.png";